import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AddressTypeahead from "../components/AddressTypeahead";

import { submitPrimary, changeFieldValue } from "../actions/formActions";
import {
  setAddressQuery,
  selectResult,
  updateResults,
  clearResults,
  traverseUp,
  traverseDown,
  setActiveIndex
} from "../actions/typeaheadActions";
import { getFieldError } from "../store/selectors";

export const mapStateToProps = (state) => {
  const { page, address, typeahead } = state;
  const { design } = page;
  const { results, activeIndex, query } = typeahead;
  const error = getFieldError(state, "address");
  return {
    query,
    design,
    address,
    results,
    activeIndex,
    error
  };
};

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      traverseUp,
      traverseDown,
      setActiveIndex,
      setAddressQuery,
      updateResults,
      clearResults,
      selectResult,
      submitPrimary,
      changeFieldValue
    },
    dispatch
  );
};

const AddressTypeaheadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressTypeahead);

export default AddressTypeaheadContainer;
